import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../Header';
import Footer from '../../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import config from "../../common/Config";
import Swal from 'sweetalert2';
import AddCustomersForm from './AddCustomersForm';
import { setTableWidths, getTableWidths } from "../../../data/postAPi";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Ensure Bootstrap 5 JS is included

const Customers = () => {
  const customerTableRef = useRef(null);
  const customerInactiveTableRef = useRef(null);
  const newcustomerTableRef = useRef(null);
  const [custSearchValue, setCustSearchValue] = useState([]);
  const [custInactiveSearchValue, setCustInactiveSearchValue] = useState([]);
  const accessToken = localStorage.getItem('accessToken');
  const company_tax_type = localStorage.getItem('company_tax_type');
  const showContraPrice = localStorage.getItem("showContraPrice");
  const [showPwdModal, setShowPwdModal] = useState(false);
  const [pwdCustomerId, setPwdCustomerId] = useState(null);
  const [pwdCustomerName, setPwdCustomerName] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [pwdLoading, setPwdLoading] = useState(false);
  const [colWidths, setColWidths] = useState([60, 120, 120, 200, 150, 150, 150, 150, 100]);
  const userId = localStorage.getItem("userId");
  const tableName = "customerTable";
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  const debouncedSetTableWidths = useRef(
    debounce((userId, tableName, widths) => {
      setTableWidths(userId, tableName, widths);
    }, 500)
  ).current;
  const startResizing = (index, e, tableType) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = colWidths[index];
    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
      setColWidths((widths) => {
        const updated = [...widths];
        updated[index] = newWidth;
        debouncedSetTableWidths(userId, tableName, updated);
        return updated;
      });
    };
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };
  const fetchWidths = async () => {
    try {
      const res = await getTableWidths(userId, tableName);
      if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
        setColWidths(res.data.widths);
      } else {
        setColWidths([60, 120, 120, 200, 150, 150, 150, 150, 100]);
      }
    } catch (e) {
      setColWidths([60, 120, 120, 200, 150, 150, 150, 150, 100]);
    }
  };

  // useEffect(() => {
  //   const savedWidths = localStorage.getItem(LOCAL_STORAGE_KEY);
  //   if (savedWidths) {
  //     try {
  //       setColWidths(JSON.parse(savedWidths));
  //     } catch (e) {}
  //   }
  // }, []);

  const addResizerListeners = (tableId) => {
    const resizers = document.querySelectorAll(`#${tableId} .th-resizer`);
    resizers.forEach((resizer, index) => {
      const handler = (e) => {
        startResizing(index, e, tableId);
      };
      resizer.addEventListener('mousedown', handler);
      resizer._resizerHandler = handler;
    });
  };

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `.th-resizer:hover {background-color: rgba(0,0,0,0.3)!important;} .resizable-header {position:relative;user-select:none;}`;
    document.head.appendChild(styleSheet);
    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      ['neworderTable', 'neworderInactiveTable', 'newCustomerTable'].forEach((id) => {
        addResizerListeners(id);
        const ths = document.querySelectorAll(`#${id} thead th`);
        ths.forEach((th, idx) => {
          th.style.width = colWidths[idx] + 'px';
        });
      });
    }, 200);
  }, []);

  // Initialize customer table
  const initializeCustomerTable = () => {
    const $table = $(customerTableRef.current);
    const searchValue = $('#searchValue').val();

    if (!$.fn.DataTable.isDataTable($table)) {
    $table.DataTable({
      processing: true,
      serverSide: true,
      ajax: {
        url: `${config.API_URL}/get_active_customer`,
        type: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: function (d) {
          return $.extend({}, d, {
            draw: d.draw,
            start: d.start,
            length: d.length,
            searchValue: searchValue
          });
        },
        dataSrc: function (json) {
          setTimeout(fetchWidths, 0);
          return Array.isArray(json.data) ? json.data : [];
        }
      },
      language: {
        paginate: {
          first: 'First',
          last: 'Last',
          next: 'Next',
          previous: 'Previous',
        },
        search: 'Search:',
      },
      columns: [
        { data: null, width: "6%", className: 'text-center', render: function (data, type, row, meta) { return meta.row + meta.settings._iDisplayStart + 1; } },
        { data: 'account_no', width: '4%' },
        { data: null, width: '10%', render: function (data, type, row) { return `<span style="text-transform: none;">${row.company}</span>`; } },
        { data: null, render: function (data, type, row) { return `<span style="text-transform: none;">${row.name}</span>`; } },
        { data: null, render: function (data, type, row) { return `<span class="text-lowercase">${row.email.toLowerCase()}</span>`; } },
        { 
  data: 'phone', 
  className: 'dt-body-left' // Use DataTables' standard class for left alignment
},
        { data: 'vat_no' },
        { data: 'product_price_type', width: '5%', className: 'text-center' },
        {
          data: null,
          title: 'Action',
          render: function (data, type, row) {
            const isActive = row.status == "1";
            const toggleText = isActive ? "Active" : "Inactive";
            const toggleClass = isActive ? "text-success" : "text-danger";

            let contraPriceLink = '';
            if (showContraPrice === 'Y') {
              contraPriceLink = `
                <li>
                  <a class="deductionbtn reject-btn" href="${config.BASE_URL}/customer/contra_price/${row.id}" title="Contra P">
                    <i class="bi bi-tags"></i> Contra Price
                  </a>
                </li>`;
            }

            return `
              <div style="display: flex; align-items: center; gap: 10px;">
                <div class="action-popdot">
                  <a class="icon" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-three-dots"></i>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                    <li>
                      <a href="#" class="toggle-status ${toggleClass}" data-id="${row.id}" data-status="${row.status}">
                        <i class="bi bi-toggle-on"></i> ${toggleText}
                      </a>
                    </li>
                    <li>
                      <a class="deductionbtn reject-btn" href="${config.BASE_URL}/customer/edit_customer/${row.id}" title="Edit">
                        <i class="bi bi-pencil-square"></i> Edit
                      </a>
                    </li>
                    ${contraPriceLink}
                    <li>
                      <a class="deductionbtn reject-btn change-password-link" href="#" data-id="${row.id}" data-name="${row.name}" title="Change Password">
                        <i class="bi bi-key"></i> Change Password
                      </a>
                    </li>
                  </ul>
                </div>
              </div>`;
          }
        }

      ],
      columnDefs: [
        { orderable: false, targets: '_all' },
        { targets: 2, render: function (data) { return data === '1' ? 'Active' : 'Inactive'; } }
      ],
      pageLength: 50,
    });

    // Event handler for status change
    $table.on('change', '.switch-input', function () {
      const id = $(this).data('id');
      const status = this.checked ? 1 : 0;
      handleChangeStatus(id, status);
    });

    // Event handler for status change (for toggle-status link)
    $table.on('click', '.toggle-status', function (e) {
      e.preventDefault();
      const id = $(this).data('id');
      const currentStatus = $(this).data('status');
      const newStatus = currentStatus == "1" ? 0 : 1;
      handleChangeStatus(id, newStatus);
    });

    // Add event handler for Change Password pop
    $table.on('click', '.change-password-link', function (e) {
      e.preventDefault();
      const id = $(this).data('id');
      const name = $(this).data('name');
      setPwdCustomerId(id);
      setPwdCustomerName(name || '');
      setShowPwdModal(true);
      setNewPassword('');
    });
  } else {
    $table.DataTable().ajax.reload(null, false); 
  }
  };

  // Handle changing customer status
  const handleChangeStatus = async (id, status) => {
    const formData = new FormData();
    formData.append('status', status);
    formData.append('id', id);
    const apiUrl = `${config.API_URL}/update_customer_status`;

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to change status');
      }

      const data = await response.json();

      Swal.fire({
        title: 'Success',
        text: 'Status changed successfully.',
        icon: 'success',
        showConfirmButton: false,
        timer: 1500,
      });

      initializeCustomerTable();
      initializeInactiveCustomerTable();
      initializeNewCustomerTable();
    } catch (error) {
      console.error('Error status change:', error);
    }
  };

  // Password change handler
  const handlePasswordChange = async () => {
    if (!newPassword || newPassword.length > 6) {
      Swal.fire({
        title: "Error",
        text: "Password must be at least 6 characters.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }
    setPwdLoading(true);
    try {
        const formData = new FormData();
        formData.append('customer_id', pwdCustomerId);
        formData.append('password', newPassword);
        const response = await fetch(
        `${config.API_URL}/update_customer_password`,
        {
          method: "POST",
          headers: {
          authorization: `Bearer ${accessToken}`,
        },
          body:formData,
        }
      );
     
      const data = await response.json();
      if (data.status === true) {
        Swal.fire({
          title: "Success!",
          text: "Password updated successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
        setShowPwdModal(false);
        setNewPassword('');
        setPwdCustomerId(null);
      } else {
        Swal.fire({
          title: "Failed!",
          text: data.message || "Password update failed.",
          icon: "error",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Failed!",
        text: "Password update failed.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
    }
    setPwdLoading(false);
  };

  useEffect(() => {
    if (accessToken == null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    initializeCustomerTable();
    initializeInactiveCustomerTable();
     initializeNewCustomerTable();
    // return () => {
    //   if (customerTableRef.current && $.fn.DataTable.isDataTable(customerTableRef.current)) {
    //     $(customerTableRef.current).DataTable().destroy();
    //   }
    // };
  }, [custSearchValue]);
 
//InactiveCustomerTable
  const initializeInactiveCustomerTable = () => {
    const $table = $(customerInactiveTableRef.current);
    const searchValue = $('#searchValue').val();
    
    if (!$.fn.DataTable.isDataTable($table)) {


    $table.DataTable({
      processing: true,
      serverSide: true,
      ajax: {
        url: `${config.API_URL}/get_inctive_customer`,
        type: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: function (d) {
          return $.extend({}, d, {
            draw: d.draw,
            start: d.start,
            length: d.length,
            searchValue: searchValue
          });
        },
        dataSrc: function (json) {
          return Array.isArray(json.data) ? json.data : [];
        }
      },
      language: {
        paginate: {
          first: 'First',
          last: 'Last',
          next: 'Next',
          previous: 'Previous',
        },
        search: 'Search:',
      },
      columns: [
        { data: null, width: "6%",className: 'text-center', render: function (data, type, row, meta) { return meta.row + meta.settings._iDisplayStart + 1; } },
        { data: 'account_no', width: '4%' },
        { data: null, width: '10%', render: function (data, type, row) { return `<span style="text-transform: none;">${row.company}</span>`; } },
        { data: null, render: function (data, type, row) { return `<span style="text-transform: none;">${row.name}</span>`; } },
        { data: null, render: function (data, type, row) { return `<span class="text-lowercase">${row.email.toLowerCase()}</span>`; } },
        { 
  data: 'phone', 
  className: 'dt-body-left' // Use DataTables' standard class for left alignment
},
        { data: 'vat_no' },
          { data: 'product_price_type', width: '5%', className: 'text-center' },
        {
          data: null,
          title: 'Action',
          render: function (data, type, row) {
            const isActive = row.status == "1";
            const toggleText = isActive ? "Active" : "Inactive";
            const toggleClass = isActive ? "text-success" : "text-danger";
              let contraPriceLink = '';
            if (showContraPrice === 'Y') {
              contraPriceLink = `
                <li>
                  <a class="deductionbtn reject-btn" href="${config.BASE_URL}/customer/contra_price/${row.id}" title="Contra P">
                    <i class="bi bi-tags"></i> Contra Price
                  </a>
                </li>`;
            }
            return `
              <div style="display: flex; align-items: center; gap: 10px;">
                <div class="action-popdot">
                  <a class="icon" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-three-dots"></i>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                    <li>
                      <a href="#" class="toggle-status ${toggleClass}" data-id="${row.id}" data-status="${row.status}">
                        <i class="bi bi-toggle-on"></i> ${toggleText}
                      </a>
                    </li>
                    <li>
                      <a class="deductionbtn reject-btn" href="${config.BASE_URL}/customer/edit_customer/${row.id}" title="Edit">
                        <i class="bi bi-pencil-square"></i> Edit
                      </a>
                    </li>
                    ${contraPriceLink}
                    <li>
                      <a class="deductionbtn reject-btn" href="${config.BASE_URL}/customer/change_password/${row.id}" title="Change Password">
                        <i class="bi bi-key"></i> Change Password
                      </a>
                    </li>
                  </ul>
                </div>
              </div>`;
          }
        }
      ],
      columnDefs: [
        { orderable: false, targets: '_all' },
        { targets: 2, render: function (data) { return data === '1' ? 'Active' : 'Inactive'; } }
      ],
      pageLength: 50,
    });

    // Event handler for status change
    $table.on('change', '.switch-input', function () {
      const id = $(this).data('id');
      const status = this.checked ? 1 : 0;
      handleChangeStatus(id, status);
    });

    $table.on('click', '.toggle-status', function (e) {
      e.preventDefault();
      const id = $(this).data('id');
      const currentStatus = $(this).data('status');
      const newStatus = currentStatus == "1" ? 0 : 1;
      handleChangeStatus(id, newStatus);
    });
  } else {
    $table.DataTable().ajax.reload(null, false); 
  }
  };


  const initializeNewCustomerTable = () => {
    const $table = $(newcustomerTableRef.current);
    const searchValue = $('#searchValue').val();
    
    if (!$.fn.DataTable.isDataTable($table)) {


    $table.DataTable({
      processing: true,
      serverSide: true,
      ajax: {
        url: `${config.API_URL}/get_new_customer`,
        type: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: function (d) {
          return $.extend({}, d, {
            draw: d.draw,
            start: d.start,
            length: d.length,
            searchValue: searchValue
          });
        },
        dataSrc: function (json) {
          return Array.isArray(json.data) ? json.data : [];
        }
      },
      language: {
        paginate: {
          first: 'First',
          last: 'Last',
          next: 'Next',
          previous: 'Previous',
        },
        search: 'Search:',
      },
      columns: [
        { data: null, width: "6%", className: 'text-center', render: function (data, type, row, meta) { return meta.row + meta.settings._iDisplayStart + 1; } },
        { data: 'account_no', width: '4%' },
        { data: null, width: '10%', render: function (data, type, row) { return `<span style="text-transform: none;">${row.company}</span>`; } },
        { data: null, render: function (data, type, row) { return `<span style="text-transform: none;">${row.name}</span>`; } },
        { data: null, render: function (data, type, row) { return `<span class="text-lowercase">${row.email.toLowerCase()}</span>`; } },
        { 
          data: 'phone', 
          className: 'dt-body-left' // Use DataTables' standard class for left alignment
        },
        { data: 'vat_no' },
        { data: 'product_price_type', width: '5%', className: 'text-center' },
        {
          data: null,
          title: 'Action',
          render: function (data, type, row) {
            const isActive = row.status == "1";
            const toggleText = isActive ? "Active" : "Inactive";
            const toggleClass = isActive ? "text-success" : "text-danger";
            let contraPriceLink = '';
            if (showContraPrice === 'Y') {
              contraPriceLink = `
                <li>
                  <a class="deductionbtn reject-btn" href="${config.BASE_URL}/customer/contra_price/${row.id}" title="Contra P">
                    <i class="bi bi-tags"></i> Contra Price
                  </a>
                </li>`;
            }
            return `
              <div style="display: flex; align-items: center; gap: 10px;">
                <div class="action-popdot">
                  <a class="icon" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-three-dots"></i>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                    <li>
                      <a href="#" class="toggle-status ${toggleClass}" data-id="${row.id}" data-status="${row.status}">
                        <i class="bi bi-toggle-on"></i> ${toggleText}
                      </a>
                    </li>
                    <li>
                      <a class="deductionbtn reject-btn" href="${config.BASE_URL}/customer/edit_customer/${row.id}" title="Edit">
                        <i class="bi bi-pencil-square"></i> Edit
                      </a>
                    </li>
                     ${contraPriceLink}
                    <li>
                      <a class="deductionbtn reject-btn" href="${config.BASE_URL}/customer/change_password/${row.id}" title="Change Password">
                        <i class="bi bi-key"></i> Change Password
                      </a>
                    </li>
                  </ul>
                </div>
              </div>`;
          }
        }
      ],
      columnDefs: [
        { orderable: false, targets: '_all' },
        { targets: 2, render: function (data) { return data === '1' ? 'Active' : 'Inactive'; } }
      ],
      pageLength: 50,
    });

    // Event handler for status change
    $table.on('change', '.switch-input', function () {
      const id = $(this).data('id');
      const status = this.checked ? 1 : 0;
      handleChangeStatus(id, status);
    });

    $table.on('click', '.toggle-status', function (e) {
      e.preventDefault();
      const id = $(this).data('id');
      const currentStatus = $(this).data('status');
      const newStatus = currentStatus == "1" ? 0 : 1;
      handleChangeStatus(id, newStatus);
    });
  } else {
    $table.DataTable().ajax.reload(null, false); 
  }
  };
  return (
    <div>
      <AddCustomersForm />
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#"><i className="fa fa-home"></i></a> &gt; <a href="Dashboard">Master</a> &gt; <span className="last-crumb">Customer</span>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="">
          <div className="row">
            <div className="col-12">
              <div className='bank-pagearea'>
                <div>
                  <div style={{ float: "right" }}>
                    <a href="#" className="create-catalogue-btn" style={{ marginBottom: "-10px" }} data-bs-toggle="modal" data-bs-target="#add-customer" >Add Customer</a>
                  </div>
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#eur" type="button" role="tab" aria-controls="eur" aria-selected="true"> Customers </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#gbp" type="button" role="tab" aria-controls="gbp" aria-selected="false"> Inactive Customers </button>
                    </li>
                      <li className="nav-item" role="presentation">
                      <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#newcustomers" type="button" role="tab" aria-controls="newcustomers" aria-selected="false"> New Customers </button>
                    </li>
                  </ul>
                  <div className="tab-content fulltable-area" id="myTabContent">
                    <div className="tab-pane fade show active" id="eur" role="tabpanel" aria-labelledby="eur-tab">
                      <div className="backlist-content-area">
                        <div className="verical-scrl-wrapper customer-table" id="style-3">
                          <table className="table table-bordered dataTable resizable" id="neworderTable" ref={customerTableRef} style={{ width: '100%' }}>
                            <thead>
                              <tr>
                                {["#", "A/C No.", "Company", "Name", "Email Address", "Phone", `${company_tax_type} No.`, "Product Band", "Action"].map((header, idx) => (
                                  <th
                                    key={header}
                                    className="resizable-header"
                                    style={{ width: colWidths[idx], minWidth: 50, position: "relative", padding: "8px" }}
                                  >
                                    {header}
                                    {idx < colWidths.length - 1 && (
                                      <div
                                        className="th-resizer"
                                        data-column-index={idx}
                                        title="Drag to resize column"
                                        style={{ position: 'absolute', right: '-2px', top: 0, width: '5px', height: '100%', cursor: 'col-resize', zIndex: 999, userSelect: 'none' }}
                                      />
                                    )}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody></tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="tab-pane fade" id="gbp" role="tabpanel" aria-labelledby="gbp-tab">
                      <div className="backlist-content-area">
                        <div className="verical-scrl-wrapper common-table customer-table" id="style-3">
                          <table className="table table-bordered dataTable resizable" id="neworderInactiveTable" ref={customerInactiveTableRef} style={{ width: '100%' }}>
                            <thead>
                              <tr>
                                {["#", "A/C No.", "Company", "Name", "Email Address", "Phone", `${company_tax_type} No.`, "Product Band", "Action"].map((header, idx) => (
                                  <th
                                    key={header}
                                    className="resizable-header"
                                    style={{ width: colWidths[idx], minWidth: 50, position: "relative", padding: "8px" }}
                                  >
                                    {header}
                                    {idx < colWidths.length - 1 && (
                                      <div
                                        className="th-resizer"
                                        data-column-index={idx}
                                        title="Drag to resize column"
                                        style={{ position: 'absolute', right: '-2px', top: 0, width: '5px', height: '100%', cursor: 'col-resize', zIndex: 999, userSelect: 'none' }}
                                      />
                                    )}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody></tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane fade" id="newcustomers" role="tabpanel" aria-labelledby="newcustomers-tab">
                      <div className="backlist-content-area">
                        <div className="verical-scrl-wrapper common-table customer-table" id="style-3">
                          <table className="table table-bordered dataTable resizable" id="newCustomerTable" ref={newcustomerTableRef} style={{ width: '100%' }}>
                            <thead>
                              <tr>
                                {["#", "A/C No.", "Company", "Name", "Email Address", "Phone", `${company_tax_type} No.`, "Product Band", "Action"].map((header, idx) => (
                                  <th
                                    key={header}
                                    className="resizable-header"
                                    style={{ width: colWidths[idx], minWidth: 50, position: "relative", padding: "8px" }}
                                  >
                                    {header}
                                    {idx < colWidths.length - 1 && (
                                      <div
                                        className="th-resizer"
                                        data-column-index={idx}
                                        title="Drag to resize column"
                                        style={{ position: 'absolute', right: '-2px', top: 0, width: '5px', height: '100%', cursor: 'col-resize', zIndex: 999, userSelect: 'none' }}
                                      />
                                    )}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody></tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {/* Password Change Modal */}
      {showPwdModal && (
        <div className="modal show" style={{display: 'block', background: 'rgba(0,0,0,0.3)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Change Password
                  {pwdCustomerName && (
                    <span style={{ fontWeight: 400, marginLeft: 10, fontSize: 16 }}>
                      ({pwdCustomerName})
                    </span>
                  )}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowPwdModal(false)}></button>
              </div>
              <div className="modal-body">
                <label>New Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value.replace(/[^0-9]/g, ''))}
                  minLength={6}
                  placeholder="Enter new password"
                  disabled={pwdLoading}
                  autoComplete="new-password"
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary btn-sm" onClick={() => setShowPwdModal(false)} disabled={pwdLoading}>Cancel</button>
                <button type="button" className="acceptbtn" onClick={handlePasswordChange} disabled={pwdLoading}>
                  {pwdLoading ? "Saving..." : "Change Password"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Customers;
